angular
  .module("admin.campaigns")
  .controller(
    "CampaignsEditModalCtrl",
    function (
      mode,
      campaignId,
      PlansResource,
      CampaignsResource,
      $uibModalInstance,
      moment,
      $timeout,
      $document
    ) {
      let ctrl = this;
      this.alerts = [];
      
      const scrollToTop = () => {
        $timeout(() => {
          const modalWindow = $document[0].querySelector('[uib-modal-window="modal-window"]');
          if (modalWindow) {
            modalWindow.scrollTop = 0;
            modalWindow.scrollTo && modalWindow.scrollTo(0, 0);
          }
        }, 100);
      };

      switch (mode) {
        case "create":
          this.title = "Nova Promoção";
          this.model = {
            cycles: null,
            campaign: {
              isActive: true,
            },
          };

          PlansResource.query(
            {
              type: "pj",
            },
            (data) => {
              ctrl.model.campaignDiscounts = data.data.map((plan) => {
                return {
                  plan: plan,
                  enabled: true,
                  unitPrice: plan.monthlyPrice / 100,
                };
              });
            }
          );

          break;
        case "edit": {
          this.title = "Editar Promoção";
          PlansResource.query(
            {
              type: "pj",
            },
            (plans) => {
              CampaignsResource.get({ id: campaignId }, (response) => {
                const campaignDiscounts = response.data.campaignDiscounts;

                this.model = {
                  campaign: response.data,
                  campaignDiscounts: [],
                  cycles: response.data.cycles,
                  period: {
                    startDate: moment.utc(response.data.startDate).format('YYYY-MM-DD'),
                    endDate: moment.utc(response.data.endDate).format('YYYY-MM-DD'),
                  },
                };

                for (const plan of plans.data) {
                  const discount = campaignDiscounts.find(
                    (discount) => discount.planId === plan.id
                  );

                  if (discount) {
                    discount.enabled = true;
                    discount.unitPrice = discount.unitPrice / 100;
                    discount.plan = plan;
                    this.model.campaignDiscounts.push(discount);
                    continue;
                  }

                  this.model.campaignDiscounts.push({
                    plan: plan,
                    enabled: false,
                    unitPrice: null,
                  });
                }
              });
            }
          );
          break;
        }
      }
      this.dismiss = function () {
        $uibModalInstance.dismiss();
      };
      this.save = function (frm) {
        frm.$setSubmitted();
        
        if (!frm.$valid) {
          this.alerts = [
            {
              message: "Por favor, preencha todos os campos obrigatórios antes de salvar.",
              type: "danger",
            },
          ];
          
          scrollToTop();
          
          return;
        }

        this.model.campaign.startDate = moment(
          this.model.period.startDate
        ).format("YYYY-MM-DD HH:mm:ss");
        this.model.campaign.endDate = moment(this.model.period.endDate).format(
          "YYYY-MM-DD HH:mm:ss"
        );

        const payload = {
          name: this.model.campaign.name,
          code: this.model.campaign.code,
          description: this.model.campaign.description,
          startDate: this.model.campaign.startDate,
          endDate: this.model.campaign.endDate,
          isActive: this.model.campaign.isActive,
          cycles: this.model.cycles,
          campaignDiscounts: this.model.campaignDiscounts
            .filter((discount) => discount.enabled)
            .map((discount) => ({
              campaignId: discount.campaignId || undefined,
              planId: discount.plan.id,
              unitPrice: discount.unitPrice * 100,
            })),
        };

        this.alerts = [];

        if (mode === "create") {
          CampaignsResource.create(
            payload,
            () => {
              this.alerts = [];
              $uibModalInstance.close();
            },
            (err) => {
              this.alerts = [
                {
                  message:
                    (err.data && err.data.message) || "Erro ao criar promoção",
                  type: "danger",
                },
              ];
              
              scrollToTop();
            }
          );
        } else {
          CampaignsResource.update(
            { id: campaignId },
            payload,
            () => {
              this.alerts = [];
              $uibModalInstance.close();
            },
            (err) => {
              this.alerts = [
                {
                  message:
                    (err.data && err.data.message) || "Erro ao editar promoção",
                  type: "danger",
                },
              ];
              
              scrollToTop();
            }
          );
        }
      };
    }
  );
